import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_PRODUCTION_API_URL || 'https://api.kundlishastra.com')
  : (process.env.REACT_APP_API_URL || 'http://localhost:5001');

const inp = {
  width: '100%',
  padding: '0.55rem 0.75rem',
  border: '1.5px solid #d6bcab',
  borderRadius: '8px',
  fontSize: '0.9rem',
  outline: 'none',
  boxSizing: 'border-box',
  background: '#fffaf7',
};

export default function ChangePasswordModal({ isOpen, onClose, userEmail, hasPassword }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword]         = useState('');
  const [confirm, setConfirm]                 = useState('');
  const [loading, setLoading]                 = useState(false);
  const [error, setError]                     = useState('');
  const [success, setSuccess]                 = useState('');

  if (!isOpen) return null;

  const reset = () => { setCurrentPassword(''); setNewPassword(''); setConfirm(''); setError(''); setSuccess(''); };

  const handleClose = () => { reset(); onClose(); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (newPassword.length < 6) return setError('Password must be at least 6 characters');
    if (newPassword !== confirm)  return setError('Passwords do not match');

    setLoading(true);
    try {
      const payload = { email: userEmail, newPassword };
      if (hasPassword) payload.currentPassword = currentPassword;
      const { data } = await axios.post(`${API_URL}/api/simple-auth/set-password`, payload);
      if (data.success) {
        setSuccess('Password updated! You can now log in with your password.');
        // Update localStorage session so button label updates on next render
        try {
          const stored = JSON.parse(localStorage.getItem('kundli-session') || '{}');
          if (stored.user) { stored.user.hasPassword = true; localStorage.setItem('kundli-session', JSON.stringify(stored)); }
        } catch (_) {}
        setTimeout(handleClose, 2200);
      } else {
        setError(data.error || 'Failed to update password');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ks-modal-scrim" style={{ position:'fixed', inset:0, zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }}>
      <div style={{ background:'#ffffff', borderRadius:'16px', padding:'2rem', width:'100%', maxWidth:'400px', boxShadow:'0 8px 30px rgba(0,0,0,0.06), 0 20px 50px rgba(0,0,0,0.1)', border:'1px solid rgb(254 215 170 / 0.45)' }}>
        {/* Header */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.25rem' }}>
          <div>
            <h3 style={{ margin:0, fontSize:'1.15rem', fontWeight:700, color:'#78350f' }}>
              {hasPassword ? '🔑 Change Password' : '🔑 Set a Password'}
            </h3>
            <p style={{ margin:'0.2rem 0 0', fontSize:'0.78rem', color:'#92400e' }}>
              {hasPassword
                ? 'Enter your current password, then choose a new one'
                : 'Set a password to secure your account and log in faster next time'}
            </p>
          </div>
          <button onClick={handleClose} style={{ background:'none', border:'none', fontSize:'1.3rem', cursor:'pointer', color:'#999', lineHeight:1 }}>×</button>
        </div>

        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:'0.8rem' }}>
          {hasPassword && (
            <div>
              <label style={{ fontSize:'0.8rem', fontWeight:600, color:'#555', display:'block', marginBottom:'0.3rem' }}>Current Password</label>
              <input type="password" placeholder="Your current password" value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)} style={inp} required />
            </div>
          )}
          <div>
            <label style={{ fontSize:'0.8rem', fontWeight:600, color:'#555', display:'block', marginBottom:'0.3rem' }}>New Password</label>
            <input type="password" placeholder="Min 6 characters" value={newPassword}
              onChange={e => setNewPassword(e.target.value)} style={inp} required />
          </div>
          <div>
            <label style={{ fontSize:'0.8rem', fontWeight:600, color:'#555', display:'block', marginBottom:'0.3rem' }}>Confirm New Password</label>
            <input type="password" placeholder="Repeat new password" value={confirm}
              onChange={e => setConfirm(e.target.value)} style={inp} required />
          </div>

          {error   && <p style={{ margin:0, color:'#dc2626', fontSize:'0.82rem', background:'#fef2f2', padding:'0.5rem 0.75rem', borderRadius:'8px' }}>{error}</p>}
          {success && <p style={{ margin:0, color:'#16a34a', fontSize:'0.82rem', background:'#f0fdf4', padding:'0.5rem 0.75rem', borderRadius:'8px' }}>{success}</p>}

          <button type="submit" disabled={loading} style={{ marginTop:'0.25rem', background: loading ? '#ccc' : 'linear-gradient(90deg,#b45309,#d97706)', color:'#fff', border:'none', borderRadius:'10px', padding:'0.7rem', fontWeight:700, fontSize:'0.95rem', cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Updating…' : (hasPassword ? 'Change Password' : 'Set Password')}
          </button>
        </form>
      </div>
    </div>
  );
}
